import { toast } from 'sonner';
//
import { Card, CardContent } from './ui/card';

import { Button } from './ui/button';
import { Input } from './ui/input';
//
import { Phone, Mail, MessageCircle } from 'lucide-react';

const contactInfo = [
  {
    icon: <Phone className="w-5 h-5" />,
    title: 'Phone',
    value: '+91 87544 88883',
    description: 'Available 24/7 for your service',
    link: 'tel:+918939411000'
  },
  {
    icon: <Mail className="w-5 h-5" />,
    title: 'Email',
  value: 'info@blucon.co.in',
    description: 'We respond within 24 hours',
  link: 'mailto:info@blucon.co.in'
  },
  {
    icon: <MessageCircle className="w-5 h-5" />,
    title: 'WhatsApp',
    value: '+91 90036 62666',
    description: 'Quick replies on WhatsApp',
    link: 'https://wa.me/919003662666'
  }
];

const ContactSection = () => {
  // ...existing code...
  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold leading-tight mb-4">
            Get in Touch
          </h2>
          <p className="text-lg text-gray-700">
            We would love to hear from you. Please fill out the form below or reach out to us through the provided contact information.
          </p>
        </div>
        <Card className="border-0 shadow-lg shadow-gray-300/20 drop-shadow-sm mb-12">
          <CardContent className="p-8 bg-green-50 rounded-[15px]">
            <form
              id="contactForm"
              className="space-y-6"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget as HTMLFormElement;
                const formData = new window.FormData(form);
                // const name = formData.get('name');
                // const email = formData.get('email');
                // const phone = formData.get('phone');
                // const message = formData.get('message') || '';
                // const waMsg = `Name: ${name}%0AEmail: ${email}%0APhone: ${phone}%0AMessage: ${message}`;
                const res = await fetch('/sendmail.php', {
                  method: 'POST',
                  body: formData
                });
                if (res.ok) {
                  toast.success('Thank you! Your message was sent.');
                } else {
                  toast.error('There was an error sending your message. Please try again.');
                }
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <Input
                    name="name"
                    placeholder="Your Name (Letters only)"
                    pattern="[A-Za-z\s]+"
                    title="Only letters and spaces are allowed"
                    required
                    className="h-12 px-4 bg-white border rounded-lg text-gray-600 placeholder-gray-400 focus:ring-1 border-gray-200 focus:border-teal-500 focus:ring-teal-500"
                  />
                </div>
                <div>
                  <Input
                    name="email"
                    type="email"
                    placeholder="Your Email"
                    required
                    className="h-12 px-4 bg-white border rounded-lg text-gray-600 placeholder-gray-400 focus:ring-1 border-gray-200 focus:border-teal-500 focus:ring-teal-500"
                  />
                </div>
                <div>
                  <Input
                    name="phone"
                    type="tel"
                    inputMode="numeric"
                    autoComplete="tel"
                    placeholder="Your Mobile (10 digits)"
                    pattern="^[0-9]{10}$"
                    title="Enter 10-digit mobile number (numbers only)"
                    maxLength={10}
                    required
                    className="h-12 px-4 bg-white border rounded-lg text-gray-600 placeholder-gray-400 focus:ring-1 border-gray-200 focus:border-teal-500 focus:ring-teal-500"
                  />
                </div>
              </div>
              <div className="flex justify-center mt-6">
                <Button 
                  type="submit"
                  className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg h-12 min-w-[200px] flex items-center justify-center gap-2 text-[16px]"
                >
                  Submit
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    <path fillRule="evenodd" d="M3 10a1 1 0 011-1h10a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                  </svg>
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 drop-shadow-lg">
          {contactInfo.map((info, index) => (
            <Card key={index} className="border-0 shadow-lg shadow-amber-100/20 hover:shadow-xl hover:shadow-amber-100/30 transition-all duration-300">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="p-3 bg-amber-100 rounded-lg text-teal-600">
                    {info.icon}
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-gray-900 mb-1">{info.title}</h4>
                    {info.link ? (
                      <a
                        href={info.link}
                        target={info.link.startsWith('http') ? '_blank' : undefined}
                        rel="noopener noreferrer"
                        className="text-lg text-teal-700 font-medium mb-1 hover:underline cursor-pointer block"
                      >
                        {info.value}
                      </a>
                    ) : (
                      <p className="text-lg text-teal-700 font-medium mb-1">{info.value}</p>
                    )}
                    <p className="text-sm text-gray-600">{info.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="grid lg:grid-cols-1 gap-8 mt-12 mb-12">
          <Card className="border-0 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
            <CardContent className="p-8">
              <h3 className="text-xl font-semibold mb-4">
                Why Choose Blucon Sunrise?
              </h3>
              <ul className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-2 text-amber-100">
                <li>• Prime location with excellent connectivity</li>
                <li>• World-class amenities and facilities</li>
                <li>• Premium construction quality</li>
                <li>• Trusted developer with proven track record</li>
                <li>• Ready to move-in homes</li>
                <li>• Flexible payment options available</li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;